import script from "./sidebarTextList.vue?vue&type=script&setup=true&lang=ts"
export * from "./sidebarTextList.vue?vue&type=script&setup=true&lang=ts"

import "./sidebarTextList.vue?vue&type=style&index=0&id=6642c09e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6642c09e"]])

export default __exports__